<template>
  <div class="filter-not-matches-error">
    <div class="filter-not-matches-error__content">
      <i class="icon-filters-rd md color-primary"></i>
      <div class="filter-not-matches-error__message">
        <span class="filter-not-matches-error__title">{{ translate('rdUseLessFilters') }}</span>
        <span class="filter-not-matches-error__description">{{
          translate('rdFilterNotMatches')
        }}</span>
      </div>
    </div>
    <div class="filter-not-matches-error__button">
      <Button :label="translate('rdClearAllFilters')" @click="$emit('clearFilter')" />
    </div>
  </div>
</template>

<script>
import { Button } from 'rhg-vue-components'

export default {
  name: 'FilterNotMatchesComponent',
  components: { Button }
}
</script>

<style lang="scss">
.filter-not-matches-error {
  display: flex;
  flex-wrap: wrap;
  padding: 2.5rem;
  background: #fcf0f1;
  @media (min-width: 992px) {
    flex-wrap: nowrap;
  }

  &__content {
    display: flex;
    flex-wrap: nowrap;
  }

  &__message {
    display: flex;
    flex-direction: column;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &__title {
    font-weight: bold;
    font-size: 14px;
  }

  &__description {
    font-size: 12px;
  }

  &__button {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2rem;

    @media (min-width: 992px) {
      width: auto;
      margin-top: 0;
    }
  }
}
</style>
